import React, { useState } from "react";
import CrudPage from "@/components/CrudPage";
import { StatusBadge, useSuppliers } from "@/components/shared";
import Crews from "@/pages/Crews";
import Timesheets from "@/pages/Timesheets";
import ComplianceTab, { ComplianceBadge } from "@/components/ComplianceTab";
import { HardHat, UsersThree, Clock } from "@phosphor-icons/react";

const EMPLOYMENT_OPTS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Not Active" },
];

function WorkersList() {
  const suppliers = useSuppliers();
  return (
    <CrudPage
      title="Workers"
      subtitle="Operators, labourers and other workers available for allocation"
      endpoint="/operators"
      dynamicOptions={{ supplier: suppliers, employment_status: EMPLOYMENT_OPTS }}
      extraTabs={[
        { key: "compliance", label: "Compliance", render: ({ form, setForm }) => <ComplianceTab form={form} setForm={setForm} /> },
      ]}
      columns={[
        { key: "name", label: "Name", render: (v) => <span className="font-semibold">{v}</span> },
        { key: "employee_no", label: "Employee #" },
        { key: "supplier", label: "Supplier" },
        { key: "phone", label: "Phone" },
        { key: "skills", label: "Skills / Tickets", render: (v) => (v || []).length ? (
          <span className="flex flex-wrap gap-1">
            {v.map((s) => (
              <span key={s} className="inline-block bg-gray-100 border border-gray-300 text-gray-700 text-[11px] font-semibold px-1.5 py-0.5" data-testid={`skill-pill-${s}`}>{s}</span>
            ))}
          </span>
        ) : "—" },
        { key: "pin", label: "Sign-In PIN", render: (v) => <span className="font-mono tracking-widest">{v || "—"}</span> },
        { key: "compliances", label: "Compliance", render: (v, row) => <ComplianceBadge worker={row} /> },
        { key: "employment_status", label: "Status", render: (v) => <StatusBadge value={v || "active"} /> },
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "employee_no", label: "Employee #" },
        { key: "supplier", label: "Supplier", type: "select" },
        { key: "phone", label: "Phone" },
        { key: "pin", label: "Sign-In PIN (auto if blank)" },
        { key: "employment_status", label: "Status", type: "select", default: "active" },
        { key: "last_location", label: "Last Location" },
        { key: "skills", label: "Skills / Tickets", type: "tags", full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}

export default function Operators() {
  const [tab, setTab] = useState("workers");
  return (
    <div className="h-full flex flex-col bg-surface-page">
      <div className="flex items-center gap-1 bg-surface-page px-4 pt-3 shrink-0">
        <div className="flex items-center bg-surface-inset rounded-[999px] p-0.5">
        <button onClick={() => setTab("workers")} data-testid="workers-tab-list"
          className={`px-3.5 h-8 rounded-[999px] text-[12px] font-bold uppercase tracking-[0.04em] inline-flex items-center gap-1.5 ${tab === "workers" ? "bg-equipr-yellow text-black" : "text-ink-secondary hover:text-ink-primary"}`}>
          <HardHat size={14} weight="bold" /> Workers
        </button>
        <button onClick={() => setTab("crews")} data-testid="workers-tab-crews"
          className={`px-3.5 h-8 rounded-[999px] text-[12px] font-bold uppercase tracking-[0.04em] inline-flex items-center gap-1.5 ${tab === "crews" ? "bg-equipr-yellow text-black" : "text-ink-secondary hover:text-ink-primary"}`}>
          <UsersThree size={14} weight="bold" /> Crews
        </button>
        <button onClick={() => setTab("timesheets")} data-testid="workers-tab-timesheets"
          className={`px-3.5 h-8 rounded-[999px] text-[12px] font-bold uppercase tracking-[0.04em] inline-flex items-center gap-1.5 ${tab === "timesheets" ? "bg-equipr-yellow text-black" : "text-ink-secondary hover:text-ink-primary"}`}>
          <Clock size={14} weight="bold" /> Timesheets
        </button>
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        {tab === "workers" ? <WorkersList /> : tab === "crews" ? <Crews /> : <Timesheets />}
      </div>
    </div>
  );
}
